module.exports = __webpack_public_path__ + "img/maps_user_2.c80106c2.svg";